import React from 'react';
import './Navbar.css';

function Navbar() {
  return (
    <header className="Navbar">
        <a href="."><h1>BELOVED MONSTERS</h1>
        <h2>by Janet Bruesselbach</h2></a>
    </header>
  )
}
export default Navbar